import {NgModule} from '@angular/core';
import {CriminalGridIndexComponent} from './criminal-grid-index.component';
import {SettingsComponent} from './Components/settings/settings.component';
import {CriminalGridTableComponent} from './Components/criminal-grid-table/criminal-grid-table.component';
import {CriminalSubCategoryComponent} from './Components/criminal-sub-category/criminal-sub-category.component';
import {CriminalGridDialogsModule} from './Components/dialogs/criminal-grid-dialogs.module';
import {ChangeLogDetailsListingComponent} from './Components/change-log/change-log-details-listing/change-log-details-listing.component';
import {ChangeLogSummaryListingComponent} from './Components/change-log/change-log-summary-listing/change-log-summary-listing.component';
import {SharedComponentsModule} from '../shared-components-module/shared-components.module';
import { CriminalGridEvictionsComponent } from './Components/criminal-grid-evictions/criminal-grid-evictions.component';
import { CriminalGridBankruptcyComponent } from './Components/criminal-grid-bankruptcy/criminal-grid-bankruptcy.component';
import { MaterialModule } from '../shared-components-module/material.module';

@NgModule({
  declarations: [
    CriminalGridIndexComponent,
    SettingsComponent,
    CriminalGridTableComponent,
    CriminalSubCategoryComponent,
    ChangeLogDetailsListingComponent,
    ChangeLogSummaryListingComponent,
    CriminalGridEvictionsComponent,
    CriminalGridBankruptcyComponent
  ],
  exports: [
    CriminalGridIndexComponent
  ],
  imports: [
    SharedComponentsModule,
    MaterialModule,
    CriminalGridDialogsModule,
  ]
})
export class CriminalGridModule {
}
